import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';
import Marquee from 'react-fast-marquee';
import { tickerAPI } from '../../services/api';

const FinancialTicker = () => {
  const [tickerData, setTickerData] = useState([
    { symbol: 'USD/TRY', name: 'Dolar', price: 34.25, change: 0.12, change_percent: 0.35 },
    { symbol: 'EUR/TRY', name: 'Euro', price: 37.10, change: 0.18, change_percent: 0.49 },
    { symbol: 'GBP/TRY', name: 'Sterlin', price: 43.85, change: -0.22, change_percent: -0.50 },
    { symbol: 'ALTIN/GR', name: 'Altın', price: 2890, change: 35.50, change_percent: 1.24 },
    { symbol: 'BIST100', name: 'BIST 100', price: 11250, change: 125, change_percent: 1.12 },
    { symbol: 'BTC/USD', name: 'Bitcoin', price: 97500, change: 1850, change_percent: 1.93 },
    { symbol: 'ETH/USD', name: 'Ethereum', price: 3450, change: -45, change_percent: -1.29 },
    { symbol: 'PETROL', name: 'Brent Petrol', price: 82.45, change: 0.65, change_percent: 0.79 },
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTickerData();
    // Auto-refresh every 5 minutes (300_000 ms)
    const interval = setInterval(fetchTickerData, 300000);
    return () => clearInterval(interval);
  }, []);

  const fetchTickerData = async () => {
    try {
      const response = await tickerAPI.getData();
      if (response.data && response.data.length > 0) {
        setTickerData(response.data);
      }
    } catch (error) {
      console.error('Ticker error:', error);
      // Keep using fallback data
    }
  };

  const formatPrice = (price) => {
    if (price >= 10000) {
      return price.toLocaleString('tr-TR', { maximumFractionDigits: 0 });
    }
    return price.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div data-testid="financial-ticker" className="bg-[#0A0F1A] border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center h-10">
          {/* Label */}
          <div className="flex items-center gap-2 pr-4 border-r border-gray-700 flex-shrink-0">
            <Activity className="w-4 h-4 text-green-400 animate-pulse" />
            <span className="text-xs font-bold text-gray-400 uppercase tracking-wider hidden sm:block">
              PİYASALAR
            </span>
          </div>

          {/* Ticker */}
          <div className="flex-1 overflow-hidden">
            <Marquee gradient={false} speed={50} pauseOnHover className="py-2">
              <div className="flex items-center">
                {tickerData.map((item, index) => (
                  <div key={index} className="flex items-center mx-6">
                    <span className="text-gray-400 text-xs font-semibold uppercase mr-2">
                      {item.symbol}
                    </span>
                    <span className="text-white font-mono font-bold text-sm mr-2">
                      {formatPrice(item.price)}
                    </span>
                    <span 
                      className={`flex items-center text-xs font-mono font-bold px-1.5 py-0.5 rounded ${
                        item.change_percent >= 0 
                          ? 'text-green-400 bg-green-400/10' 
                          : 'text-red-400 bg-red-400/10'
                      }`}
                    >
                      {item.change_percent >= 0 ? (
                        <TrendingUp className="w-3 h-3 mr-0.5" />
                      ) : (
                        <TrendingDown className="w-3 h-3 mr-0.5" />
                      )}
                      {item.change_percent >= 0 ? '+' : ''}{item.change_percent.toFixed(2)}%
                    </span>
                  </div>
                ))}
              </div>
            </Marquee>
          </div>

          {/* Time */}
          <div className="hidden md:flex items-center pl-4 border-l border-gray-700 flex-shrink-0">
            <span className="text-gray-500 text-xs font-mono">
              {new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialTicker;
